
















































import { ConfiguredAppIntegration } from '@/features/apps/shared/models/configuredAppIntegration';
import { Component, Prop, Vue } from 'vue-property-decorator';
import Modal from '@/shared/components/Modal.vue';
import ContentHighlightsArticleAppEdit from './ContentHighlightsArticleAppEdit.vue';
import ContentHighlightsListAppEdit from './ContentHighlightsListAppEdit.vue';
import { ArticleAppConfig } from './models/ArticleApp';
import { ListApp, ListAppItem } from './models/ListApp';

@Component({
	components: {
		Modal,
		ContentHighlightsArticleAppEdit,
		ContentHighlightsListAppEdit,
	},
})
export default class ContentHighlightsEditModal extends Vue {
	@Prop() public appConfig: ConfiguredAppIntegration;

	public isLoading = false;

	public articleAppConfig: ArticleAppConfig | null = null;

	public listAppConfig: ListApp | null = null;

	public $refs: {
		appConfigComponent: ContentHighlightsArticleAppEdit | ContentHighlightsListAppEdit
	};

	public isInvalid = false;

	public mounted() {
		if (this.isArticleApp()) {
			this.articleAppConfig = {
				image_url: this.appConfig.config.image_url,
				header_text: this.appConfig.config.header_text,
				body_text: this.appConfig.config.body_text,
				article_url: this.appConfig.config.article_url,
				link_label: this.appConfig.config.link_label,
				$templateName: 'SingleHighlight',
			};
		} else {
			this.parseListAppConfig();
		}
	}

	public isArticleApp(): boolean {
		return this.appConfig.config.$templateName === 'SingleHighlight';
	}

	public async saveApp() {
		this.$refs.appConfigComponent?.$v.$touch();
		if (this.$refs.appConfigComponent?.$v.$invalid) {
			return;
		}
		this.$emit(
			'save',
			this.isArticleApp() ? {
				config: {
					...this.articleAppConfig
				},
				installedAppId: this.appConfig.installedAppId
			} : this.getListAppFromConfig()
		);
	}

	public handleInput(isInvalid: boolean) {
		this.isInvalid = isInvalid;
	}

	private parseListAppConfig() {
		const items: ListAppItem[] = [
			{
				url: '',
				description: '',
				label: '',
				image: '',
			},
		];

		for (const [key, value] of Object.entries(this.appConfig.config).filter(
			([k]) => k.includes('url')
		)) {
			const parts = key.split('_');
			if (!items[Number(parts[parts.length - 1]) - 1]) {
				items[Number(parts[parts.length - 1]) - 1] = {
					url: '',
					description: '',
					label: '',
					image: '',
				};
			}
			items[Number(parts[parts.length - 1]) - 1][
				parts[parts.length - 2] as keyof ListAppItem
			] = value as string;
		}

		this.listAppConfig = {
			heading: this.appConfig.config.header,
			$templateName: 'ListOfHighlights',
			items,
		};
	}

	private getListAppFromConfig(): ConfiguredAppIntegration {
		const connectListApp: ConfiguredAppIntegration = {
			installedAppId: this.appConfig.installedAppId,
			config: {
				header: this.listAppConfig?.heading,
				$templateName: 'ListOfHighlights',
			},
		};

		if (!this.listAppConfig?.items) {
			throw new Error('App doesn\'t contain any items');
		}

		for (let i = 0; i < this.listAppConfig.items.length; i += 1) {
			connectListApp.config[`url_${i + 1}`] = this.listAppConfig.items[i].url;
			connectListApp.config[`url_description_${i + 1}`] =
			this.listAppConfig.items[i].description;
			connectListApp.config[`url_label_${i + 1}`] = this.listAppConfig.items[i].label;
			connectListApp.config[`url_image_${i + 1}`] = this.listAppConfig.items[i].image;
		}

		return connectListApp;
	}
}
